<template>
  <div class="b-card-container">
    <div class="bc-header-container">
      <div class="bc-header">
        Thermostat Detail
      </div>
      <div class="bc-header">
        Total: {{ tZones.length }}
      </div>
    </div>
    <div class="bc-table-container">
      <div v-for="item in properties" :key="item.uid" class="mb-6">
        <div class="med sac__font-18 border-bottom flex-row just-between">
          <div>
            {{ item.serviceAddress.address1 }},
            {{ item.serviceAddress.city }}
          </div>
          <div>Zones: {{ item.zones.length }}</div>
        </div>
        <SmartThermostatCard v-for="el in item.zones" :key="el.zoneId" :item="el" />
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import SmartThermostatCard from './SmartThermostatCard.vue';

export default {
  name: 'SmartThermostatDetail',
  components: { SmartThermostatCard },
  mixins: [customerDetailMixin],
  computed: {
    properties() {
      const props = [];
      this.hubs.forEach((element) => {
        let prop = props.find((x) => x.serviceAddress.address1 === element.serviceAddress.address1);
        if (!prop) {
          prop = { ...element, zones: [] };
          props.push(prop);
        }
        const zones = this.tZones.filter((y) => y?.serialNumber?.includes(element.uid));
        prop.zones.push(...zones);
      });
      return props;
    },
  },
  mounted() {
    if (this.customer && this.customer.id) {
      this.$store.dispatch('getCustomerThermostats');
    }
  },
};
</script>

<style lang="scss" scoped>
.thermostat-module {
  background-color: #F0F5FA;
  box-shadow: 0px 3px 6px rgba(9, 15, 32, 0.07);

  padding: 10px 15px 10px 15px;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  text-align: center;
  width: 210px;

  p {
    color: #7F8290;
    margin-bottom: 3px;
    padding-bottom: 0;

    & .setpoint {
      color: $N95;
      margin-bottom: 3px;
      padding-bottom: 0;
    }
  }
}

.border-bottom {
  border-bottom: 2px solid $N20;
  margin-bottom: 15px;
  padding-bottom: 10px;
}

.mode-ico {
  height: 24px;
  width: 24px;
  margin-right: 3px;
}

.mode-ico-small {
  height: 19px;
  width: 19px;
  margin-right: 3px;
}

.connection-card {
  background-color: #F6F6F7;
  border-radius: 4px;
  padding-top: 3px;
  padding-bottom: 3px;

  p {
    margin-bottom: 0
  }
}
</style>
